import { GenreRow } from "@/components/GenreRow";
import { fetchTrending } from "@/lib/api";

export const WatchingNowRow = () => (
  <GenreRow title="What People Are Watching Now" tag="watching-now" anchorId="watching-now" queryFn={() => fetchTrending(15)} />
);
